import { createContext, useState, type Dispatch, type SetStateAction, type PropsWithChildren, type FunctionComponent } from 'react';
import { type SearchState } from '../../helpers/search-helper/search-filter-helper';

export type SearchSetState = [SearchState, Dispatch<SetStateAction<SearchState>>];

type SearchProviderProps = {
	internalId: number;
	uniqueId: number;
	isNonstock: boolean;
};

const defaultState: SearchState = {
	page: 1,
	pageSize: 16,
	sortBy: 'BEST_MATCH',
	facets: [],
	internalId: 0,
	uniqueId: 0,
	isNonstock: false
};

export const ProductSearchContext = createContext<SearchSetState>([defaultState, () => {}]);

export const ProductSearchProvider: FunctionComponent<PropsWithChildren<SearchProviderProps>> = ({
	internalId,
	uniqueId,
	isNonstock,
	children
}) => {
	const initialState: SearchState = {
		...defaultState,
		internalId,
		uniqueId,
		isNonstock
	};

	const state = useState<SearchState>(initialState);
	return <ProductSearchContext.Provider value={state}>{children}</ProductSearchContext.Provider>;
};
